/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Llms_TxtInputs */

const en_directory_agent_readiness_check_llms_txt = /** @type {(inputs: Directory_Agent_Readiness_Check_Llms_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`llms.txt`)
};

const zh_directory_agent_readiness_check_llms_txt = /** @type {(inputs: Directory_Agent_Readiness_Check_Llms_TxtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`llms.txt`)
};

/**
* | output |
* | --- |
* | "llms.txt" |
*
* @param {Directory_Agent_Readiness_Check_Llms_TxtInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_llms_txt = /** @type {((inputs?: Directory_Agent_Readiness_Check_Llms_TxtInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Llms_TxtInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_llms_txt(inputs)
	return zh_directory_agent_readiness_check_llms_txt(inputs)
});
export { directory_agent_readiness_check_llms_txt as "directory.agent_readiness.check.llms_txt" }